export const getStartingPrice = (category) => {
  const prices = {
    landing: "100 000 ₽",
    markup: "150 000 ₽",
    corporate: "250 000 ₽",
    ecommerce: "400 000 ₽",
    mobile: "700 000 ₽",
    webapp: "1 000 000 ₽",
    uidesign: "170 000 ₽",
    redesign: "200 000 ₽",
    support: "50 000 ₽/мес",
    automation: "400 000 ₽",
    devops: "30 000 ₽",
  };
  return prices[category] || "Цена по запросу";
};
// строки с в стоимость включено :
export const getIncludedFeatures = (category) => {
  const features = {
    landing: [
      "Уникальный дизайн или шаблон",
      "Адаптивная верстка",
      "Базовое наполнение контентом",
      "Установка на хостинг",
    ],
    markup: [
      "Уникальный дизайн или шаблон",
      "Адаптивная верстка",
      "Базовое наполнение контентом",
      "Установка на хостинг",
    ],
    corporate: [
      "Индивидуальный или брендированный шаблон",
      "Исследование рынка и конкурентов",
      "Адаптивная вёрстка",
      "Базовое наполнение разделов",
      "Базовая защита",
      "Оптимизация скорости загрузки",
      "Размещение на хостинге",
      "SEO-основа",
      "Техническая гарантия 45 дней",
    ],
    ecommerce: [
      "Индивидуальный дизайн или адаптация шаблона",
      "Каталог товаров и фильтры",
      "Корзина и оформление заказа",
      "Интеграция с платёжными системами",
      "Адаптивная верстка",
      "Базовое добавление товаров",
      "Оптимизация скорости",
      "Установка на хостинг и проверка работы",
    ],
    mobile: [
      "Прототипирование и аналитика",
      "Дизайн интерфейса (UI/UX)",
      "Разработка под Android ",
      "Интеграция с сервером/API",
      "Адаптация под разные устройства",
      "Публикация в Google Play",
      "Базовая аналитика",
    ],
    webapp: [
      "SPA/PWA архитектура",
      "Аутентификация",
      "Backend-интеграции",
      "Адаптивная вёрстка",
      "PWA-база",
    ],
    uidesign: [
      "Исследование аудитории",
      "Wireframes и прототип ",
      "UI дизайн экранов",
      "Дизайн-система",
      "Передача в разработку",
    ],
    redesign: [
      "Аудит текущего сайта",
      "Новая концепция дизайна",
      "Улучшение UX",
      "Адаптация под мобильные",
      "Перенос контента",
    ],
    support: [
      "Регулярные обновления",
      "Мониторинг ",
      "Бэкапы",
      "Багфиксы ",
      "Консультации",
    ],
    automation: [
      "Аналитика процессов",
      "Проектирование решения",
      "Интеграции ",
      "Обучение ",
    ],
    devops: [
      "Настройка окружения ",
      "Деплой приложений",
      "Мониторинг ",
      "Бэкапы",
      "Оптимизация ",
    ],
  };
  return (
    features[category] || [
      "Индивидуальный подход",
      "Качественная реализация",
      "Техническая поддержка",
    ]
  );
};
// строка с доп услуги
export const getAdditionalOptions = (category) => {
  const options = {
    landing: [
      "Расширенная техподдержка",
      "Интеграция с социальными сетями",
      "Мультиязычная версия",
    ],
    markup: [
      "Расширенная техподдержка",
      "Интеграция с социальными сетями",
      "Мультиязычная версия",
    ],
    corporate: [
      "Полное наполнение корпоративным контентом",
      "Расширенная техподдержка",
      "Интеграция с социальными платформами",
      "Мультиязычный сайт",
      "Раздел «Новости» или «Блог»",
      "Интеграция с внешними сервисами",
      "Личный кабинет или внутренняя зона",
    ],
    ecommerce: [
      "Полное наполнение товарами",
      "Расширенная техподдержка",
      "Интеграция со службами доставки",
      "Личный кабинет покупателя",
      "Интеграция с маркетплейсами",
      "Email- и SMS-уведомления",
      "Бонусная система / скидки",
      "Мультиязычный магазин",
    ],
    mobile: [
      "Разработка серверной части (бэкенд)",
      "Поддержка и развитие",
      "Интеграции со сторонними сервисами",
      "Push-уведомления",
      "Личный кабинет / профили пользователей",
      "Работа в офлайн-режиме",
      "Мобильная аналитика и A/B-тесты",
      "Мультиязычная версия",
    ],
    webapp: [
      "Внешние API",
      "Поддержка и доработки",
      "Оптимизация производительности ",
      "UI/UX улучшения",
      "Мультиязычность",
    ],
    uidesign: [
      "A/B тесты",
      "Дизайн мобильных/веб-сервисов",
      "Сопровождение ",
      "Маркетинговые материалы",
    ],
    redesign: ["SEO при редизайне", "Новые модули", "Ускорение", "Пост-запуск"],
    support: ["Доработка функционала", "Миграции", "Безопасность", "Аналитика"],
    automation: ["Кастомные модули", "Автоуведомления ", "Масштабирование "],
    devops: ["Миграции  ", "CI/CD ", "Масштабирование ", "Безопасность "],
  };
  return (
    options[category] || [
      "Индивидуальные доработки",
      "Расширенная гарантия",
      "Срочное выполнение",
    ]
  );
};
// доп инфа в стоимость включено:
export const getFeatureDetails = (category, index) => {
  const featureDetails = {
    landing: [
      "Создаем индивидуальный дизайн, который отражает философию вашего бренда, или адаптируем premium-шаблон под ваши потребности.",
      "Полная адаптация под мобильные телефоны, планшеты и десктопы с сохранением удобства использования на всех устройствах",
      "Размещаем ваши тексты, изображения и товары, настраиваем структуру страниц и обеспечиваем корректное отображение всего контента.",
      "Берём на себя все технические задачи: размещение сайта, настройка домена, почты.",
    ],
    markup: [
      "Создаем индивидуальный дизайн, который отражает философию вашего бренда, или адаптируем premium-шаблон под ваши потребности.",
      "Полная адаптация под мобильные телефоны, планшеты и десктопы с сохранением удобства использования на всех устройствах",
      "Размещаем ваши тексты, изображения и товары, настраиваем структуру страниц и обеспечиваем корректное отображение всего контента.",
      "Берём на себя все технические задачи: размещение сайта, настройка домена, почты.",
    ],
    corporate: [
      "Создаём современный и презентабельный внешний вид, соответствующий стилю компании.",
      "Изучаем отраслевые сайты, чтобы предложить конкурентное решение.",
      "Сайт корректно работает и выглядит на смартфонах, планшетах и компьютерах.",
      'Наполняем ключевые страницы: "О компании", "Услуги", "Контакты", "Вакансии" и др.',
      "Защита от типичных угроз и автоматических атак, настройка HTTPS.",
      "Готовим сайт к быстрой и стабильной работе, даже при высокой нагрузке.",
      "Устанавливаем сайт на выбранный хостинг, подключаем домен, настраиваем почту.",
      "Заголовки, мета-теги, карта сайта и другие элементы для лучшей индексации в поисковиках..",
      "Поддержка после запуска: исправление возможных технических неполадок.",
    ],
    ecommerce: [
      "Создаём визуально привлекательный и удобный магазин, ориентированный на конверсии.",
      "Реализуем структуру с категориями, фильтрами, сортировкой и страницами товара.",
      "Удобный путь от выбора до покупки: корзина, оформление, подтверждение.",
      "Подключаем способы оплаты: карты, ЮKassa, Tinkoff, PayPal и др.",
      "Ваш магазин работает и выглядит корректно на всех устройствах.",
      "Добавим стартовые карточки товаров с описанием, фото и ценами.",
      "Быстрая загрузка страниц — залог хорошей конверсии и SEO.",
      "Полноценный запуск магазина на вашем домене.",
    ],
    mobile: [
      "Определим ключевые сценарии, составим карту экранов, учтём цели проекта.",
      "Создадим современный, удобный и визуально цельный интерфейс, адаптированный под мобильные платформы.",
      "Используем нативные технологии: Kotlin, React Native и др.",
      "Подключим приложение к вашему бэкенду или разработаем собственный.",
      "Приложение будет корректно работать на разных экранах и разрешениях.",
      "Помогаем с загрузкой, оформлением и прохождением модерации.",
      "Установка систем отслеживания событий (Firebase, AppMetrica и др.)",
    ],
    webapp: [
      "маршрутизация, состояние, кэш.",
      "роли, сессии, защита маршрутов.",
      "подключение REST API.",
      "управление данными и правами.",
      "оптимизация для мобильных.",
      "манифест, offline-кэш, иконки.",
    ],
    uidesign: [
      "цели, сценарии, конкурентный анализ.",
      "структура и сценарии взаимодействия.",
      "макеты, состояния, адаптив.",
      "компоненты, токены, гайдлайны.",
      "спецификации, ассеты.",
    ],
    redesign: [
      "проблемы UX/техники/SEO.",
      "визуальный стиль и структура.",
      "сценарии, формы, навигация.",
      "responsive и перформанс.",
      "бережная миграция разделов.",
    ],
    support: [
      "плагины, зависимости.",
      "доступность, ошибки, алерты.",
      "расписание, проверка восстановления.",
      "оперативное устранение ошибок.",
      "по эксплуатации и развитию.",
    ],
    automation: [
      "карта текущих операций и узких мест.",
      "схемы данных и ролевая модель.",
      "подключение ключевых внешних сервисов. ",
      "гайды и онбординг команды. ",
    ],
    devops: [
      " Linux, Docker, базы, кеши.",
      "конфиг, сборка, релиз.",
      "метрики, логи, алерты. ",
      "политика резервирования и восстановление.",
      "тюнинг производительности. ",
    ],
  };

  return (
    featureDetails[category]?.[index] || "Подробное описание данной функции"
  );
};
// доп инфа в дополнительные опции
export const getOptionDetails = (category, index) => {
  const optionDetails = {
    landing: [
      "Оперативное решение технических вопросов, настройка, мониторинг и помощь при сбоях — 7 дней в неделю.",
      "Настраиваем подключение к популярным платформам: виджеты отзывов, автоматическая публикация новостей, формы авторизации через соцсети.",
      "Поддержка нескольких языков с динамическим переключением и отдельным контентом",
    ],
    markup: [
      "Оперативное решение технических вопросов, настройка, мониторинг и помощь при сбоях — 7 дней в неделю.",
      "Настраиваем подключение к популярным платформам: виджеты отзывов, автоматическая публикация новостей, формы авторизации через соцсети.",
      "Поддержка нескольких языков с динамическим переключением и отдельным контентом",
    ],
    corporate: [
      "Подготовим и разместим тексты, структуру и изображения на всех страницах.Полное наполнение корпоративным контентом",
      "Сопровождение, обновления, внедрение новых функций и технический контроль.",
      "Кнопки, ленты, виджеты, отзывы и другие элементы взаимодействия.",
      "Реализуем поддержку нужных языков: переключение, перевод, локализация.",
      "Для публикации обновлений, новостей компании и экспертных материалов.",
      "CRM, helpdesk, ERP, системы учёта, формы заявок, чат-боты и пр.",
      "Если необходимо — сделаем закрытую часть сайта для клиентов или сотрудников.",
    ],
    ecommerce: [
      "Массовая загрузка карточек, характеристик, фото, категорий.",
      "Сопровождение, обновления, добавление функциональности, мониторинг.",
      "СДЭК, Почта РФ, курьеры — автоматический расчёт стоимости и сроков.",
      "Заказы, избранное, история покупок, статусы и уведомления.",
      "Выгрузка на Ozon, Wildberries, Яндекс Маркет и др.",
      "Оповещения о заказах, акциях, статусах доставки.",
      "Промокоды, накопительные программы, акции.",
      "Поддержка нескольких языков для международных продаж.",
    ],
    mobile: [
      "Админка, база данных, API, авторизация, хранение данных и т.д.",
      "Регулярные обновления, внедрение нового функционала, оптимизация.",
      "Платежи, карты, уведомления, чат, авторизация через соцсети и др.",
      "Настройка персонализированных уведомлений для удержания пользователей.",
      "Регистрация, авторизация, настройки, история действий.",
      "Возможность пользоваться приложением без постоянного подключения к интернету.",
      "Глубокий анализ поведения пользователей и оптимизация интерфейсов.",
      "Локализация интерфейса для работы на нескольких языках.",
    ],
    webapp: [
      "CRM, платежи, карты, вебхуки.",
      "релизы, фиксы, улучшения.",
      "профилирование, lazy-load.",
      "итерации по данным аналитики.",
      "локализация интерфейса и контента.",
    ],
    uidesign: [
      "гипотезы, сценарии, анализ результатов",
      "адаптация под платформы.",
      "развитие дизайн-системы, ревью спринтов.",
      "баннеры, лендинги, промо-экраны.",
    ],
    redesign: [
      "редиректы, мета, индексация.",
      "чат, аналитика, формы.",
      "оптимизация изображений, кэш.",
      "сопровождение и мелкие доработки.",
    ],
    support: [
      "новые модули, интеграции.",
      "перенос на новый хостинг.",
      "WAF/SSL, аудит и хардненг.",
      "подключение и настройка метрик.",
    ],
    automation: [
      "под отраслевые задачи.",
      "почта/мессенджеры/боты.",
      "оптимизация под рост и нагрузку.",
    ],
    devops: [
      "переезд между серверами/облаками.",
      "GitLab CI/GitHub Actions/Jenkins конвейеры.",
      "балансировка, авто-скейл, кэш-слои.",
      "firewall, SSL/TLS, VPN, секрет-менеджмент.",
    ],
  };

  return (
    optionDetails[category]?.[index] ||
    "Подробное описание данной опции. Стоимость и сроки обсуждаются индивидуально."
  );
};
